import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "clientCodeMasked", "clientCodeRevealed",
    "toggleButton", "eyeIcon", "eyeSlashIcon"
  ]

  toggleClientCode() {
    const masked = this.clientCodeMaskedTarget
    const revealed = this.clientCodeRevealedTarget

    if (masked.classList.contains("hidden")) {
      masked.classList.remove("hidden")
      revealed.classList.add("hidden")
      this.eyeIconTarget.classList.remove("hidden")
      this.eyeSlashIconTarget.classList.add("hidden")
    } else {
      masked.classList.add("hidden")
      revealed.classList.remove("hidden")
      this.eyeIconTarget.classList.add("hidden")
      this.eyeSlashIconTarget.classList.remove("hidden")
    }
  }

  copyValue(event) {
    event.stopPropagation()
    const text = event.currentTarget.dataset.copyText
    if (!text) return
    this._copyToClipboard(text, event.currentTarget)
  }

  _copyToClipboard(text, button) {
    const originalHTML = button.innerHTML
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => {
        this._showCopySuccess(button, originalHTML)
      }).catch(() => {
        this._fallbackCopy(text, button, originalHTML)
      })
    } else {
      this._fallbackCopy(text, button, originalHTML)
    }
  }

  _fallbackCopy(text, button, originalHTML) {
    const textArea = document.createElement("textarea")
    textArea.value = text
    textArea.style.position = "fixed"
    textArea.style.left = "-999999px"
    document.body.appendChild(textArea)
    textArea.select()
    try {
      document.execCommand("copy")
      this._showCopySuccess(button, originalHTML)
    } catch (_e) {
      // silent fail
    }
    document.body.removeChild(textArea)
  }

  _showCopySuccess(button, originalHTML) {
    button.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 8l3 3 7-7"/></svg>'
    button.style.color = "#1E9D7C"
    setTimeout(() => {
      button.innerHTML = originalHTML
      button.style.color = ""
    }, 1500)
  }
}
